window.shareProduct = function () {
    class ShareButton extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                shareButton: this.querySelector('button'),
                successMessage: this.querySelector('[id^="ShareMessage"]'),
                urlInput: this.querySelector('input'),
                content: this.querySelector('.share-button__fallback'),
                copyButton: this.querySelector('.button-copy'),
                closeButton: this.querySelector('.share-button__close')
            }

            this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
            this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
            this.elements.closeButton.addEventListener('click', this.closeDetails.bind(this));
            document.querySelector('.background-overlay')?.addEventListener('click', this.closeDetails.bind(this));
            document.addEventListener('keydown', this.handleKeydown.bind(this));
        }

        toggleDetails(event) {
            event.preventDefault();
            event.stopPropagation();

            if (this.elements.content.classList.contains('is-open')) {
                this.closeDetails(event);
                return;
            }

            const url = this.elements.urlInput.getAttribute('data-url');

            this.getPosition();
            this.setProductInfoTop(this.getProductInfoPosition());

            this.elements.successMessage.classList.add('hidden');
            this.elements.successMessage.setAttribute('aria-hidden', 'true');
            this.elements.urlInput.value = url;
            this.elements.urlInput.classList.remove('is-copy');
            this.previouslyFocusedElement = document.activeElement;
            this.elements.content.classList.toggle('is-open');
            this.elements.content.setAttribute('aria-hidden', 'false');
            this.elements.shareButton.setAttribute('aria-expanded', 'true');
            document.querySelector('body').classList.add('modal-share-open');
            window.requestAnimationFrame(() => this.elements.closeButton.focus());
        }

        async copyToClipboard(event) {
            event.preventDefault();
            event.stopPropagation();

            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(this.elements.urlInput.value);
                } else {
                    this.elements.urlInput.select();
                    document.execCommand('copy');
                }

                this.elements.successMessage.classList.remove('hidden');
                this.elements.successMessage.setAttribute('aria-hidden', 'false');
                this.elements.urlInput.classList.add('is-copy');

                window.clearTimeout(this.copyMessageTimeout);
                this.copyMessageTimeout = window.setTimeout(() => {
                    this.elements.successMessage.classList.add('hidden');
                    this.elements.successMessage.setAttribute('aria-hidden', 'true');
                    this.elements.urlInput.classList.remove('is-copy');
                }, 3000);
            } catch (error) {
                this.elements.urlInput.focus();
                this.elements.urlInput.select();
            }
        }

        closeDetails(event) {
            event?.preventDefault();

            if (!this.elements.content.classList.contains('is-open')) return;

            const url = this.elements.urlInput.getAttribute('data-url');

            window.clearTimeout(this.copyMessageTimeout);
            this.elements.successMessage.classList.add('hidden');
            this.elements.successMessage.setAttribute('aria-hidden', 'true');
            this.elements.urlInput.value = url;
            this.elements.urlInput.classList.remove('is-copy');
            this.elements.content.classList.remove('is-open');
            this.elements.content.setAttribute('aria-hidden', 'true');
            this.elements.shareButton.setAttribute('aria-expanded', 'false');
            document.querySelector('body').classList.remove('modal-share-open');
            this.setProductInfoTop(0);

            if (this.previouslyFocusedElement instanceof HTMLElement) {
                this.previouslyFocusedElement.focus();
            }
        }

        handleKeydown(event) {
            if (event.key === 'Escape' && this.elements.content.classList.contains('is-open')) {
                this.closeDetails(event);
            }
        }

        getPosition() {
            // if (window.innerWidth <= 1024 || this.elements.shareButton.closest('[data-quick-view-popup]') != null) return;

            // const shareButtonRect = this.elements.shareButton.getBoundingClientRect()

            // const y = shareButtonRect.top;
            // const x = shareButtonRect.left;

            // const width = this.elements.content.getBoundingClientRect().width;
            // const shareHeight = shareButtonRect.height;
            // const shareWidth = shareButtonRect.width;

            // const left = x - width + shareWidth;
            // const top = y + shareHeight + 10;

            // this.elements.content.style.setProperty('--share-desk-top', top + 'px');
            // this.elements.content.style.setProperty('--share-desk-left', left + 'px');
        }

        getProductInfoPosition() {
            const stickyElement = document.querySelector('.productView-details');
            if (!stickyElement?.parentNode) return 0;

            const parentElement = stickyElement.parentNode;

            const stickyRect = stickyElement.getBoundingClientRect();
            const parentRect = parentElement.getBoundingClientRect();

            const topOffset = stickyRect.top - parentRect.top;

            return topOffset;
        }

        setProductInfoTop(top) {
            const productDetails = document.querySelector('.productView-details')
            productDetails?.style.setProperty('--sticky-top', top + 'px')
        }
    }

    if (!customElements.get('share-button')) {
        customElements.define('share-button', ShareButton);
    }
};

var shareShow = document.body.classList.contains('quick-view-show'),
    productShare = $('.halo-productView .productView-share').length;

if (document.body.classList.contains('template-product')) {
    if (!shareShow && productShare) {
        window.shareProduct();
    } else if (shareShow && productShare === 0) {
        window.shareProduct();
    }
} else {
    window.shareProduct();
}

if (!window.am2pmFancyboxShareBridge) {
    window.am2pmFancyboxShareBridge = true;

    document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const fancyboxShareButton = event.target.closest('[data-fancybox-share]');
        if (!fancyboxShareButton) return;

        const productShareButton = document.querySelector(
            '.halo-productView share-button.productView-share .share-button__button'
        );

        if (!productShareButton) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        productShareButton.click();
    }, true);
}
